/**
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2021, 2024. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 */
import React, { useContext } from "react";
import { MenuButton, MenuItem } from "@carbon/react";
import { PROP_APPCONFIG, PROP_ENUM, PROP_INTEGRATION, PROP_SECURE, PROP_TEXT } from "./Constants";
import { i18nContext } from "./table-context";
function AddPropertyBtn(_ref) {
  var addProperty = _ref.addProperty,
    buttonName = _ref.buttonName,
    disabled = _ref.disabled,
    enableAppConfig = _ref.enableAppConfig,
    title = _ref.title;
  var i18n = useContext(i18nContext);
  var titleProp = title || "";
  var renderOverflowItems = function renderOverflowItems() {
    var items = [];
    if (enableAppConfig) {
      // AppConfig is gatekeepered for now
      items.push({
        "data-type": PROP_APPCONFIG,
        "data-analytics-label": "Property Value app config property",
        disabled: disabled,
        label: i18n.messages.propertyAppConfigLabel,
        key: PROP_APPCONFIG,
        onClick: function onClick() {
          addProperty(PROP_APPCONFIG);
        }
      });
    }
    items.push({
      onClick: function onClick() {
        addProperty(PROP_ENUM);
      },
      "data-type": PROP_ENUM,
      "data-analytics-label": "Property Value single select property",
      disabled: disabled,
      key: PROP_ENUM,
      label: i18n.messages.propertyEnumLabel
    }, {
      onClick: function onClick() {
        addProperty(PROP_SECURE);
      },
      "data-type": PROP_SECURE,
      "data-analytics-label": "Property Value secure property",
      disabled: disabled,
      key: PROP_SECURE,
      label: i18n.messages.propertySecureLabel
    }, {
      onClick: function onClick() {
        addProperty(PROP_TEXT);
      },
      "data-type": PROP_TEXT,
      "data-analytics-label": "Property Value text property",
      disabled: disabled,
      key: PROP_TEXT,
      label: i18n.messages.propertyTextLabel
    }, {
      onClick: function onClick() {
        addProperty(PROP_INTEGRATION);
      },
      "data-type": PROP_INTEGRATION,
      "data-analytics-label": "Property Value integration property",
      disabled: disabled,
      key: PROP_INTEGRATION,
      label: i18n.messages.propertyIntegrationLabel
    });

    // Note: Previously we sorted the items alphabetically here, but now
    // the order is determined by the order in which they are added to the array
    var overflowItems = items.map(function (item) {
      return /*#__PURE__*/React.createElement(MenuItem, item);
    });
    return overflowItems;
  };
  return /*#__PURE__*/React.createElement(MenuButton, {
    align: "right",
    className: "ocr--property-add-btn",
    id: "add-property",
    label: buttonName,
    menuAlignment: "bottom-end",
    title: titleProp
  }, renderOverflowItems());
}
export default AddPropertyBtn;